import { render, staticRenderFns } from "./ErrorMessage.vue?vue&type=template&id=6be92fd1&"
import script from "./ErrorMessage.vue?vue&type=script&lang=js&"
export * from "./ErrorMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("Q:\\Projects\\dnx-dpn\\MarketingDb.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6be92fd1')) {
      api.createRecord('6be92fd1', component.options)
    } else {
      api.reload('6be92fd1', component.options)
    }
    module.hot.accept("./ErrorMessage.vue?vue&type=template&id=6be92fd1&", function () {
      api.rerender('6be92fd1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Components/Errors/ErrorMessage.vue"
export default component.exports